export default {
    
    // 根據不同 TA 使用相對應的影片
    target: {
        change: 'sLUwmZxd0u4',   // 轉職者
        freshman: 'l-yD0paspls', // 新鮮人
        digital: 'QGxjbOsXHSs',  // 數位人
    },

    // 問題頁影片
    q1Main: 'GR6K-F55xRw', // 問題一主影片
    q1Idle: '53GtnIQjkE0', // 問題一待機影片
    q1A:    'ngZsUz7WHWE', // 問題一選項一
    q1B:    'ubMB-M6JBq0', // 問題一選項二
    q1C:    'a-rttEFplrI', // 問題一選項三

    q2Main: 'MZWMde0ptZM', // 問題二主影片
    q2Idle: 'nNqF-32PkJY', // 問題二待機影片
    q2A:    '1zygO8mxBYs', // 問題二選項一
    q2B:    'RJzDWcRazhA', // 問題二選項二
    q2C:    'aKKhDf7r3Qo', // 問題二選項三

    q3Main: 'bA82aBFI3UY', // 問題三主影片
    q3Idle: '5EfgrczuT7E', // 問題三待機影片
    q3A:    '-inGoY0WTQw', // 問題三選項一
    q3B:    'P_BXOZNr5B0', // 問題三選項二
    q3C:    'eZq-3J0b1Z4', // 問題三選項三

    q4Main: 'KHeSIm5tdBE', // 問題四主影片
    q4Idle: 'Rh0WLGP1IxI', // 問題四待機影片
    q4A:    'qeePp18tOho', // 問題四選項一
    q4B:    'v04biScY_uo', // 問題四選項二
    q4C:    'Z0jDSaYUBEM', // 問題四選項三

    // 測驗結果影片
    result: {
        q1A: 'yocXC64Q8Ds', // 景觀型格局
        q1B: '-I3_PVbyES0', // 挑高型格局

        q2A: 'MV_Zv-oSOUY', // 親子房型格局
        q2B: 'M6DNipplfZQ', // 透天厝型格局

        q3A: 'nsJaLbXyV9A', // 採光型格局
        q3B: '6aZpPYb7YnU', // 通風型格局

        q4A: 'xWvM92P9Lq4', // 樓中樓型格局
        q4B: 'kzimfMC6IPI', // 附車位型格局

        q1C: '4mdBtIqZMKU', // 開放型格局
        q2C: '4mdBtIqZMKU', // 開放型格局
        q3C: '4mdBtIqZMKU', // 開放型格局
        q4C: '4mdBtIqZMKU', // 開放型格局
    },

    // 結尾影片
    ending: '1etiC64eI6w',

}